/**
 * @file    page-not-found.component.ts
 * @brief   Displays the 404 page.
 *
 * Copyright (c) Bsquare Corporation 2018. All rights reserved.
 */
import { Component } from '@angular/core';

/**
 * Displays the 404 page.
 */
@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss'],
})
export class PageNotFoundComponent {}
